import DeviationMediaService from '../../utils/DeviationMediaService';
import { DeviationTypes } from '../../types/deviation';
export const FIRST_IMAGE_FEATURE = 'FIRST_IMAGE_FEATURE';
export const firstImageFeature = (editorState, raw)=>{
    for(const key in raw.entityMap){
        const entity = raw.entityMap[key];
        switch(entity.type){
            case 'wix-draft-plugin-gallery':
                if (entity.data && entity.data.data) {
                    const [first] = entity.data.data;
                    if (first && mightBeADeviation(first)) {
                        return makeFeature(first);
                    }
                }
                break;
            case 'wix-draft-plugin-image':
                if (entity.data && entity.data.data && mightBeADeviation(entity.data.data)) {
                    return makeFeature(entity.data.data);
                }
                break;
            default:
        }
    }
    return {
        type: FIRST_IMAGE_FEATURE,
        data: {}
    };
};
function makeFeature(deviation) {
    return {
        type: FIRST_IMAGE_FEATURE,
        data: {
            deviation
        }
    };
}
function mightBeADeviation(obj) {
    return DeviationMediaService.getDeviationType(obj) === DeviationTypes.IMAGE;
}
